/**
 * Bundled XP-celebration SFX (`assets/Sounds/level-up.mp3` / `rank-up.mp3`).
 * Generated by `scripts/generateCelebrationSounds.py` from the celebration design's synth recipe.
 * Metro exposes different shapes per platform — normalize via `bundledMp3Module.helper`.
 */

import {
  resolveBundledMp3NativeSource,
  resolveBundledMp3UriForWeb,
} from './bundledMp3Module.helper';

const LEVEL_UP_MP3_MODULE = require('../../../assets/Sounds/level-up.mp3') as unknown;
const RANK_UP_MP3_MODULE = require('../../../assets/Sounds/rank-up.mp3') as unknown;

/** Native `expo-audio` source: asset module id, `{ uri }` from Metro, or null → caller uses CDN URI. */
export function getNativeLevelUpSource(): number | { uri: string } | null {
  return resolveBundledMp3NativeSource(LEVEL_UP_MP3_MODULE);
}

export function getNativeRankUpSource(): number | { uri: string } | null {
  return resolveBundledMp3NativeSource(RANK_UP_MP3_MODULE);
}

/** Web: absolute URL to bundled MP3 (for fetch / HTMLAudio). */
export function getLevelUpBundledUriForWeb(): string | null {
  return resolveBundledMp3UriForWeb(LEVEL_UP_MP3_MODULE);
}

export function getRankUpBundledUriForWeb(): string | null {
  return resolveBundledMp3UriForWeb(RANK_UP_MP3_MODULE);
}
